import React from 'react';

const Switch = () => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.583336 3.20828H12.0086L10.9626 4.2542C10.7348 4.48199 10.7348 4.85124 10.9626 5.07904C11.0767 5.19308 11.2257 5.24995 11.3751 5.24995C11.5244 5.24995 11.6734 5.19308 11.7875 5.07904L13.8292 3.03736C14.0569 2.80957 14.0569 2.44031 13.8292 2.21252L11.7875 0.170845C11.5597 -0.0569482 11.1904 -0.0569482 10.9626 0.170845C10.7348 0.398637 10.7348 0.767889 10.9626 0.995682L12.0086 2.0416H0.583336C0.261335 2.0416 0 2.30294 0 2.62494C0 2.94694 0.261335 3.20828 0.583336 3.20828Z"
      fill="var(--SECONDARY_LIGHT)"
    />
    <path
      d="M13.4167 6.7086H1.99144L3.03736 5.66267C3.26515 5.43488 3.26515 5.06563 3.03736 4.83784C2.80986 4.61004 2.44002 4.61004 2.21252 4.83784L0.170845 6.87951C-0.0569482 7.10731 -0.0569482 7.47656 0.170845 7.70435L2.21252 9.74603C2.32627 9.86007 2.47561 9.91695 2.62494 9.91695C2.77427 9.91695 2.92361 9.86007 3.03736 9.74603C3.26515 9.51824 3.26515 9.14898 3.03736 8.92119L1.99144 7.87527H13.4167C13.7387 7.87527 14 7.61393 14 7.29193C14 6.96993 13.7387 6.7086 13.4167 6.7086Z"
      fill="var(--SECONDARY_LIGHT)"
    />
  </svg>
);

export default Switch;
